export default __webpack_public_path__ + "static/media/heart-waiting-orange.9054c708.svg";